import React, { useState } from "react";

const HowToGetPregnant = ({
  formData,
  setFormData,
  nextStep,
  prevStep,
  error,
  setErrors,
  isSubmitting,
  step,
  totalSteps,
  isHighmarkPortal,
}) => {
  // State for toggles
  const [ava, setAva] = useState(formData.Ava === "Y");
  const [mira, setMira] = useState(formData.Mira === "Y");
  const [tracker, setTracker] = useState(formData.WINFertilityTracker === "Y");
  const [natural, setNatural] = useState(formData.Natural === "Y");
  const [treatment, setTreatment] = useState(formData.FertilityTreatment === "Y");
  const [localError, setLocalError] = useState(""); // For local validation

  const handleToggle = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value ? "Y" : "N",
    }));
    switch (name) {
      case "Ava": setAva(value); break;
      case "Mira": setMira(value); break;
      case "WINFertilityTracker": setTracker(value); break;
      case "Natural": setNatural(value); break;
      case "FertilityTreatment": setTreatment(value); break;
      default: break;
    }
    setLocalError(""); // Clear local validation on any toggle
    setErrors((prev) => ({ ...prev, supportMethod: undefined }));
  };

  const handleNext = (e) => {
    e.preventDefault();
    if (![ava, mira, tracker, natural, treatment].some(Boolean)) {
      setLocalError("Please select at least one option.");
      setErrors((prev) => ({ ...prev, supportMethod: "Please select at least one option." }));
      return;
    }
    setLocalError("");
    nextStep();
  };

  return (
    <div className="step-section">
      <h3 className="page-heading-secondary-black-500 mb-4">How did you get pregnant?</h3>
      
      <div className="mb-3 mt-5 container ps-0">
        
        <div className="row mb-4">
          <div className="col-9">
            <span className="me-3">Ava ovulation tracking</span>
          </div>
          <div className="col-3">
            <label className="switch me-2 mb-0">
              <input
                type="checkbox"
                className="switch-input"
                checked={ava}
                onChange={() => handleToggle("Ava", !ava)}
              />
              <span className="slider round"></span>
            </label>
          </div>
        </div>

        <div className="row mb-4">
          <div className="col-9"><span className="me-3">Mira ovulation tracking</span></div>
          <div className="col-3">
            <label className="switch me-2 mb-0">
              <input
                type="checkbox"
                className="switch-input"
                checked={mira}
                onChange={() => handleToggle("Mira", !mira)}
              />
              <span className="slider round"></span>
            </label>
          </div>
        </div>

        <div className="row mb-4">
          <div className="col-9"><span className="me-3">WINFamily app Fertility Tracker</span></div>
          <div className="col-3">
            <label className="switch me-2 mb-0">
              <input
                type="checkbox"
                className="switch-input"
                checked={tracker}
                onChange={() => handleToggle("WINFertilityTracker", !tracker)}
              />
              <span className="slider round"></span>
            </label>
          </div>
        </div>

        <div className="row mb-4">
          <div className="col-9"><span className="me-3">Natural conception</span></div>
          <div className="col-3">
            <label className="switch me-2 mb-0">
              <input
                type="checkbox"
                className="switch-input"
                checked={natural}
                onChange={() => handleToggle("Natural", !natural)}
              />
              <span className="slider round"></span>
            </label>
          </div>
        </div>

        <div className="row mb-4">
          <div className="col-9"><span className="me-3">Fertility treatment</span></div>
          <div className="col-3">
            <label className="switch me-2 mb-0">
              <input
                type="checkbox"
                className="switch-input"
                checked={treatment}
                onChange={() => handleToggle("FertilityTreatment", !treatment)}
              />
              <span className="slider round"></span>
            </label>
          </div>
        </div>
        
        
      </div>

      {/* Show validation error if needed */}
      {localError && <p className="text-danger">{localError}</p>}
      {/* Also render external error if it exists and is not about the selection */}
      {typeof error === "string" && error && error !== "Please select at least one option." && (
        <p className="text-danger">{error}</p>
      )}

      <div className="mt-5">
        {isHighmarkPortal ? (
          <div className="pagination-wrapper mt-5">
            <button className="previous-btn" onClick={prevStep} disabled={isSubmitting}></button>
            <span className="me-3">{step} of {totalSteps}</span>
            <button className="next-btn" onClick={handleNext} disabled={isSubmitting}></button>
          </div>
        ) : (
          <>
            <button className="win-btn-secondary mobile-view me-3" onClick={prevStep} disabled={isSubmitting}>Back</button>
            <button className="win-btn-primary mobile-view mt-2 mb-3" onClick={handleNext} disabled={isSubmitting}>Next</button>
          </>
        )}
      </div>
    </div>
  );
};

export default HowToGetPregnant;
